export default __webpack_public_path__ + "static/media/Positive-Space-04.119ff4ef.png";